import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='commentary-disclosure-investment-risks' // '-section-container' will be appended dynamically
    backgroundVariant='lightB'
    themeType='lightTheme'
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <Typography
          component='h2'
          nextElement='typography'>
          Investment Risks
        </Typography>
        <Typography
          align='left'
          nextElement='graphic'>
          When considering which investments to select for your specific goals, it&#39;s important to understand some of the differences between each because there is potential to lose money. Investments that have similar characteristics and behave similarly in the marketplace are referred to as asset classes. The following asset classes have different risks to consider.
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='commentary-disclosure-investment-risks-accordion'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          addFAQPageSchemaItemType={false}
          items={[
            {
              id: 'commentary-disclosure-investment-risks-accordion-equity',
              title: 'Equity',
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Stock prices and returns are typically less stable than those of bonds &#40;also known as fixed&#45;income investments&#41;. While stocks have the potential for higher gains, those gains are not guaranteed and could also lead to loss.
                </Typography>
              ),
            },
            {
              id: 'commentary-disclosure-investment-risks-accordion-small-cap-equity',
              title: 'Small Cap Equity',
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Stocks of new or smaller companies have the most equity risk because they are less established compared with medium&#45; or large&#45;company stocks.
                </Typography>
              ),
            },
            {
              id: 'commentary-disclosure-investment-risks-accordion-fixed-income',
              title: 'Fixed Income',
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  While fixed income securities usually contain less risk than other equity investments, they can still be impacted by interest rates and other factors. Some fixed income products, such as bonds, are investments that can&#39;t be used until they have matured. It&#39;s important to understand that interest rates and bond prices tend to move in opposite directions, so there are economic considerations with these investments as well.
                </Typography>
              ),
            },
            {
              id: 'commentary-disclosure-investment-risks-accordion-international',
              title: 'International',
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  International investments have additional risks to consider, including political instability and different industry practices &#40;such as accounting standards&#41;.
                </Typography>
              ),
            },
            {
              id: 'commentary-disclosure-investment-risks-accordion-real-estate',
              title: 'Real Estate',
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Investing in real estate can also be risky since there are additional economic factors that affect real estate values.
                </Typography>
              ),
            },
            {
              id: 'commentary-disclosure-investment-risks-accordion-commodities',
              title: 'Commodities',
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Commodities &#40;such as coffee or copper&#41; have prices that fluctuate more than other assets, and can be affected by economic factors as well as weather or political developments. You can invest in these types of assets either directly or through products linked to commodity prices.
                </Typography>
              ),
            },
            {
              id: 'commentary-disclosure-investment-risks-accordion-money-market',
              title: 'Money Market',
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  A money market fund is not insured or guaranteed by the Federal Deposit Insurance Corporation or any government agency. The typical goal of the fund is to preserve your investment; however, it is still possible to lose money.
                </Typography>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
